import React from 'react';
import { AmityPostDetailPage } from '@frn/amityco-ui-kit-open-source';
// import overrideStyles from '!!css-loader?{"sourceMap":false,"exportType":"string"}!./Overrides.css';

// console.log('overrideStyles', overrideStyles);
//import './Overrides.css';
import ErrorBoundary from '../../../../../../components/ErrorBoundary';
//import './Overrides.css';
//The postID is the id of the post that will be the root of this comment thread
const SocialPlusPostPage: React.FC<any> = ({ styleObject, id }) => {
  console.log('styleObject', styleObject);
  console.log('id', id);
  return (
    <div
      style={
        styleObject
          ? styleObject
          : {
              position: 'absolute',
              left: 0,
              top: '160px',
              width: '100vw',
              height: '100vh',
              overflow: 'visible'
            }
      }
      className="my-amity-wrapper"
    >
      {/* <style>{overrideStyles}</style> */}
      <ErrorBoundary>
        <AmityPostDetailPage id={id} />
      </ErrorBoundary>
    </div>
  );
};
export default SocialPlusPostPage;
